// import apiClient from './client';

// export const warehousesAPI = {
//   getAll: () => apiClient.get('/warehouses/'),
//   getById: (id) => apiClient.get(`/warehouses/${id}/`),
// };

import apiClient from './client';

export const warehousesAPI = {
  getAll: () => apiClient.get('/warehouses/'),
  getById: (id) => apiClient.get(`/warehouses/${id}/`),
  create: (data) => apiClient.post('/warehouses/', data),
  update: (id, data) => apiClient.put(`/warehouses/${id}/`, data),
  delete: (id) => apiClient.delete(`/warehouses/${id}/`),
};
